import type { Review, ServiceFilter, SortKey } from "../api/reviews";
import { SERVICES } from "../api/reviews";
import i18n from "../i18n";

export function serviceLabel(id: ServiceFilter | string): string {
  const match = SERVICES.find((s) => s.id === id);
  return match ? i18n.t(match.labelKey, { ns: "reviews" }) : String(id);
}

export function sortReviews(list: Review[], sort: SortKey): Review[] {
  const arr = list.slice();
  switch (sort) {
    case "recent":
      arr.sort((a, b) => b.date.localeCompare(a.date));
      break;
    case "oldest":
      arr.sort((a, b) => a.date.localeCompare(b.date));
      break;
    case "highest":
      arr.sort((a, b) => b.rating - a.rating || b.date.localeCompare(a.date));
      break;
    case "lowest":
      arr.sort((a, b) => a.rating - b.rating || b.date.localeCompare(a.date));
      break;
  }
  return arr;
}

export function fmtDate(iso: string): string {
  const d = new Date(iso + "T00:00:00");
  return d
    .toLocaleDateString("en-AU", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
    .toUpperCase();
}

export function fmtReplyAgo(reviewDate: string, replyDate: string): string {
  const r = new Date(reviewDate + "T00:00:00");
  const p = new Date(replyDate + "T00:00:00");
  const days = Math.round((p.getTime() - r.getTime()) / 86400000);
  if (days <= 0) return "Replied same day";
  if (days === 1) return "Replied 1 day later";
  if (days < 7) return `Replied ${days} days later`;
  if (days < 14) return "Replied 1 week later";
  return `Replied ${Math.round(days / 7)} weeks later`;
}
